// extracted by mini-css-extract-plugin
module.exports = {"dressCodeItem":"dressCodeItem--67565"};